export const REAL_HINTS = [
  'add',
  'alert',
  'arrows',
  'back',
  'check',
  'circle',
  'close',
  'cold',
  'collapse',
  'currency',
  'date',
  'delete',
  'empty',
  'expand',
  'filter',
  'forward',
  'hot',
  'negative',
  'open',
  'photo',
  'positive',
  'save',
  'seasonal',
  'sort',
  'square',
  'time',
  'vehicle'
]

export const BRANDS_HINTS = [
  'airbnb',
  'amazon',
  'apple',
  'bluetooth',
  'bootstrap',
  'codepen',
  'discord',
  'dribbble',
  'facebook',
  'github',
  'google',
  'instagram',
  'pinterest',
  'spotify',
  'youtube'
]

export const EASTER_EGG_HINTS = [
  'aliens',
  'ancient',
  'batman',
  'boo boo',
  'bruce wayne',
  'bugs bunny',
  'business socks',
  'capsicum',
  'cowabunga',
  'deadly',
  'dnd',
  'droid',
  'dungeons & dragons',
  'eww',
  'ewww',
  'firebolt',
  'flight of the conchords',
  'freckles',
  'geordi la forge',
  'gimli',
  'gotham',
  'halle berry',
  'halle berry',
  'jean-luc picard',
  'kitty',
  'kiwi',
  'legolas',
  'lumberjack',
  'magic',
  'maverick',
  'michael landon',
  'nimbus 2000',
  'pegasus',
  'retro',
  'robot',
  'skywalker',
  'stahhbucks',
  'vintage',
  'zilch'
]
